<!--
  Mobile menu

  Off-canvas menu for mobile, show/hide based on off-canvas menu state.
-->
<div *ngIf="isMenuOpen" class="relative z-20 md:hidden" role="dialog" aria-modal="true">
    <!--
      Off-canvas menu backdrop, show/hide based on off-canvas menu state.

      Entering: "transition-opacity ease-linear duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "transition-opacity ease-linear duration-300"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div *ngIf="isMenuOpen" [@backdropAnimation] class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm"></div>

    <div class="fixed inset-0 z-40 flex">
        <!--
          Off-canvas menu, show/hide based on off-canvas menu state.

          Entering: "transition ease-in-out duration-300 transform"
            From: "-translate-x-full"
            To: "translate-x-0"
          Leaving: "transition ease-in-out duration-300 transform"
            From: "translate-x-0"
            To: "-translate-x-full"
        -->
        <div [@menuAnimation] class="relative flex w-full max-w-xs flex-1 flex-col bg-secondary-900 rounded-tr-xl rounded-br-xl shadow-lg shadow-secondary-900/50 pb-4 pt-5">
            <!--
              Close button, show/hide based on off-canvas menu state.

              Entering: "ease-in-out duration-300"
                From: "opacity-0"
                To: "opacity-100"
              Leaving: "ease-in-out duration-300"
                From: "opacity-100"
                To: "opacity-0"
            -->
            <div [@closeButtonAnimation] class="absolute right-0 top-1 -mr-[3.15rem] p-1">

              <button type="button" (click)="toggleMenu()" class="flex h-12 w-12 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-white">
                  <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <span class="sr-only">Close sidebar</span>
              </button>

            </div>

            <div class="flex flex-shrink-0 items-center px-4">
                <img class="h-8 w-auto object-contain" src="../../../../assets/alternative_whihte_horizontal.png" alt="Sales OMMO" height="96" width="96">
            </div>

            <div class="mt-5 h-0 flex-1 overflow-y-auto px-2">
                <nav class="flex h-full flex-col">
                    <div class="space-y-1">

                      <!-- Tags -->
                      <button type="button" (click)="changeSidebarTab(0)" [ngClass]="sidebarTabs[0].current ? 'bg-indigo-custom' : 'text-primary-100'" class="hover:bg-indigo-custom group flex items-center rounded-md py-2 px-3 text-sm font-medium w-full cursor-pointer space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" [ngClass]="sidebarTabs[0].current ? 'text-white' : 'text-primary-100 dark:fill-[#bdc2ff]'" class="group-hover:text-primary-100 h-6 w-6">
                          <path fill-rule="evenodd" d="M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" clip-rule="evenodd" />
                        </svg>
                         <span [ngClass]="sidebarTabs[0].current ? 'text-primary-100' : 'text-primary-100'" class="text-base">
                            Tags
                         </span>
                      </button>

                      <!-- Assistant -->
                      <button type="button" (click)="changeSidebarTab(1)" [ngClass]="sidebarTabs[1].current ? 'bg-indigo-custom' : 'text-primary-100'" class="hover:bg-indigo-custom group flex items-center rounded-md py-2 px-3 text-sm font-medium w-full cursor-pointer space-x-2">
                        <svg viewBox="0 0 24 24" [ngClass]="sidebarTabs[1].current ? 'fill-white' : 'fill-primary-100 dark:fill-[#bdc2ff]'" class="group-hover:text-primary-100 h-6 w-6" fill="none">
                          <path d="M1.50213 18.0181C0.543565 16.2832 0 14.2398 0 11.9819C0 4.96193 5.30593 0 11.9967 0V3.37426C7.33393 3.37426 3.95455 6.68159 3.95455 11.9809C3.95455 12.9494 4.06742 13.8536 4.28037 14.6847C6.36754 12.979 9.06222 12.0005 12.0033 12.0005V20.6564C16.6613 20.6551 20.037 17.2877 20.0445 11.9995L12.0033 12.0005V3.37519L12.0005 3.37519V0H12.0033C12.0926 0 12.1817 0.000902758 12.2706 0.00270125C18.4358 0.126211 23.3648 4.47395 23.9424 10.7384C23.9805 11.1456 24 11.5609 24 11.9837V11.9995C23.9916 19.0431 18.6893 23.9968 12.0033 23.9981V24H0.00650025C0.00945233 21.7651 0.551753 19.7407 1.50213 18.0181Z" />
                        </svg>
                        <span [ngClass]="sidebarTabs[1].current ? 'text-primary-100' : ' text-primary-100'" class="text-base">
                          Assistant
                        </span>
                      </button>

                      <!-- Vault -->
                      <button type="button" (click)="changeSidebarTab(3)" [ngClass]="sidebarTabs[3].current ? 'bg-indigo-custom' : 'text-primary-100'" class="hover:bg-indigo-custom group flex items-center rounded-md py-2 px-3 text-sm font-medium w-full space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" [ngClass]="sidebarTabs[3].current ? 'fill-white' : 'fill-primary-100 dark:fill-[#bdc2ff]'" class="group-hover:text-primary-100 h-6 w-6">
                          <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                        </svg>
                          <span [ngClass]="sidebarTabs[3].current ? 'text-primary-100' : ' text-primary-100'" class="text-base">Vault</span>
                      </button>

                      <!-- CRM -->
                      <button type="button" (click)="changeSidebarTab(5)" [ngClass]="sidebarTabs[5].current ? 'bg-indigo-custom' : 'text-primary-100'" class="hover:bg-indigo-custom group flex items-center rounded-md py-2 px-3 text-sm font-medium w-full space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" [ngClass]="sidebarTabs[5].current ? 'fill-white' : 'fill-primary-100 dark:fill-[#bdc2ff]'" class="group-hover:text-primary-100 h-6 w-6">
                          <path fill-rule="evenodd" d="M2.25 6a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V6Zm18 3H3.75v9a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V9Zm-15-3.75A.75.75 0 0 0 4.5 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H5.25Zm1.5.75a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V6Zm3-.75A.75.75 0 0 0 9 6v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H9.75Z" clip-rule="evenodd" />
                        </svg>
                        <span [ngClass]="sidebarTabs[5].current ? 'text-primary-100' : ' text-primary-100'" class="text-base">CRM</span>
                      </button>

                    </div>
                </nav>
            </div>

        </div>

        <div class="w-14 flex-shrink-0" aria-hidden="true">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
    </div>
</div>

<header *ngIf="isLoggedIn" class="relative w-full">
    <div class="bg-secondary-900 relative z-10 flex h-16 flex-shrink-0 shadow-sm">
        <button type="button" (click)="toggleMenu()" class="border-r border-secondary-900 px-4 text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden">
            <span class="sr-only">Open sidebar</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
            </svg>
        </button>
        <div class="flex flex-1 justify-between px-4 sm:px-6">
            <div class="flex flex-1">

                <div class="flex justify-center items-center">

                    <!-- Logo -->
                    <div class="flex items-center pr-6 lg:pr-6">
                      <a routerLink="/reports" *ngIf="isMobile()">
                        <img class="h-8 w-auto object-contain" src="/assets/logo.svg" alt="Sales OMMO" height="96" width="96">
                      </a>
                      <a routerLink="/reports" *ngIf="!isMobile()">
                        <img class="md:hidden lg:block h-8 w-auto" src="/assets/alternative_whihte_horizontal.png" alt="Sales OMMO" height="96" width="96">
                        <img class="block lg:hidden h-8 w-auto object-contain" src="/assets/logo.svg" alt="Sales OMMO" height="96" width="96">
                      </a>
                    </div>

                    <!-- Back -->
                    <div class="flex items-center pr-6 lg:pr-6">
                        <button type="button" (click)="goBack()" class="focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-white hover:text-gray-300 transition-colors duration-150">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                            </svg>
                        </button>
                    </div>

                    <div class="hidden md:block md:items-center">

                      <!-- Search Person -->
                      <app-search-person [componentLocation]="'header'"></app-search-person>

                    </div>

                </div>

            </div>
            <div class="flex items-center">

              <app-header-right-side></app-header-right-side>

            </div>
        </div>
    </div>
</header>
